import IcontecResourcesScreen from './containers/icontecResourcesScreen'

export {default as IcontecResourcesScreenLayout} from './components/icontecResourcesScreenLayout'

export default IcontecResourcesScreen
